import { gsap } from "gsap";

import { AbstractSymbol } from "../../../../abstracts/elements/AbstractSymbol";
import { AbstractBitmapText } from "../../../../abstracts/graphics/AbstractBitmapText";
import { AbstractView } from "../../../../abstracts/modules/AbstractView";
import { AbstractWinScreen } from "../../../../abstracts/modules/screens/AbstractWinScreen";
import { winFontSize } from "../../../UCConfig";
import { UCFontsNames } from "../../../assetsLoader/UCAssetsNames";

export class UCWaysWinScreen extends AbstractWinScreen {
    protected waysWinText: AbstractBitmapText;

    constructor(parentContainer: AbstractView) {
        super(`UCWaysWinScreen`, parentContainer);
    }

    protected init(): void {
        super.init();

        this.totalWinText = new AbstractBitmapText(`0`, {
            fontName: UCFontsNames.UC_DEFAULT,
            fontSize: winFontSize,
        });
        this.totalWinText.name = `totalWinText`;
        this.addChild(this.totalWinText);

        this.waysWinText = new AbstractBitmapText(`ways`, {
            fontName: UCFontsNames.UC_WAYS,
            fontSize: 10,
        });
        this.waysWinText.name = `waysWinText`;
        this.waysWinText.y = this.totalWinText.y + this.totalWinText.height - 6;
        this.addChild(this.waysWinText);
    }

    public handleWaysWin(
        symbols: AbstractSymbol[],
        winAmounts: number[],
        waysNo: number,
        duration: number = 0.5
    ): gsap.core.Timeline {
        super.handleWaysWin(symbols, winAmounts, waysNo);

        const tl = gsap.timeline({
            onUpdate: () => {
                if (this.totalWinText.width > 700) {
                    const initialWidth = this.totalWinText.width;
                    this.totalWinText.width = 700;
                    this.totalWinText.height = this.totalWinText.height * (700 / initialWidth);
                }
            },
        });

        const showWinText = gsap.fromTo(
            this.totalWinText,
            { alpha: 0 },
            {
                alpha: 1,
                duration: 0.2 * duration,
                onStart: () => {
                    this.parentContainer.addChild(this);

                    this.totalWinText.updateValue(winAmounts[0].toFixed(2).toString());
                    this.totalWinText.y = waysNo === -1 ? 25 : 0;

                    this.waysWinText.alpha = 0;
                },
            }
        );
        tl.add(showWinText, 0);

        const hideWinText = gsap.fromTo(
            this.totalWinText,
            { alpha: 1 },
            {
                alpha: 0,
                duration: 0.1 * duration,
                ease: `none`,
                onComplete: () => {
                    this.parentContainer.removeChild(this);
                },
            }
        );
        tl.add(hideWinText, 0.9 * duration);

        if (waysNo !== -1) {
            const showWaysText = gsap.fromTo(
                this.waysWinText,
                { alpha: 0 },
                {
                    alpha: 1,
                    duration: 0.2 * duration,
                    onStart: () => {
                        this.waysWinText.updateValue(
                            `${waysNo} ${waysNo > 1 ? `ways` : `way`} won`
                        );
                    },
                }
            );
            tl.add(showWaysText, 0);

            const hideWaysText = gsap.fromTo(
                this.waysWinText,
                { alpha: 1 },
                {
                    alpha: 0,
                    duration: 0.1 * duration,
                    ease: `none`,
                }
            );
            tl.add(hideWaysText, 0.9 * duration);
        }

        return tl;
    }
}
